import { EnMaterialIcon } from '../../enum/en-material-icon.enum';

export interface ILettering {
    id: number;
    message: string;
    icon: EnMaterialIcon;
    state: string;
}